module.exports = __webpack_public_path__ + "img/logo.fe44bb5f.png";